(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77],{

/***/ 71162:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/umsoknir/starf",
      function () {
        return __webpack_require__(67040);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ sendEmail; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

function sendEmail(name, subject, message, file) {
    return _sendEmail.apply(this, arguments);
}
function _sendEmail() {
    _sendEmail = _asyncToGenerator(_home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(name, subject, message, file) {
        var data;
        return _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = new FormData();
                    data.append("name", name);
                    data.append("subject", subject);
                    data.append("message", message);
                    if (file) {
                        data.append("file", file);
                    }
                    return _ctx.abrupt("return", fetch("/api/sendgrid", {
                        body: data,
                        method: "POST"
                    }));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _sendEmail.apply(this, arguments);
}


/***/ }),

/***/ 80501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59433);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31494);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92469);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Input = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].input(_templateObject());
var FieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());
function FormikFileInput(props) {
    var ref;
    var ref1 = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormikContext */ .u6)(), values = ref1.values, setFieldValue = ref1.setFieldValue, getFieldMeta = ref1.getFieldMeta;
    var fileRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var meta = getFieldMeta("file");
    var showError = !!(meta.error && meta.touched);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .InputWrapper */ .SP, {
        withGutter: props.withGutter,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .InputLabel */ .AZ, {
                htmlFor: props.id,
                disabled: props.disabled,
                children: props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .InputSleeve */ .bx, {
                errorMsg: meta.error,
                showError: showError,
                info: props.info,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                        name: "file",
                        type: "file",
                        accept: "application/pdf",
                        onChange: function(event) {
                            if (!(event === null || event === void 0 ? void 0 : event.currentTarget.files) || !(event === null || event === void 0 ? void 0 : event.currentTarget.files[0])) {
                                return;
                            }
                            setFieldValue("file", event.currentTarget.files[0]);
                        },
                        ref: fileRef
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FieldWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                outlined: true,
                                onClick: function() {
                                    return fileRef.current && fileRef.current.click();
                                },
                                style: {
                                    marginRight: "16px"
                                },
                                type: "button",
                                children: "Velja skr\xe1"
                            }),
                            (ref = values.file) === null || ref === void 0 ? void 0 : ref.name
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormikFileInput);


/***/ }),

/***/ 67040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Reikningsvidskipti; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./src/api/sendgrid/index.ts
var sendgrid = __webpack_require__(28868);
// EXTERNAL MODULE: ./src/utils/email.ts
var email = __webpack_require__(78229);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/isValidPhoneNumber.js + 34 modules
var isValidPhoneNumber = __webpack_require__(6060);
// EXTERNAL MODULE: ./src/components/form/FileInput.tsx
var FileInput = __webpack_require__(80501);
// EXTERNAL MODULE: ./src/components/form/RadioButton.tsx
var RadioButton = __webpack_require__(15749);
// EXTERNAL MODULE: ./src/components/form/Select.tsx
var Select = __webpack_require__(92970);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
// EXTERNAL MODULE: ./src/components/form/CleaveInput.tsx
var CleaveInput = __webpack_require__(56791);
;// CONCATENATED MODULE: ./src/components/form/SsnInput.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SsnInput(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CleaveInput/* FormikCleaveInput */.m, _objectSpread({}, props, {
        options: {
            numericOnly: true,
            blocks: [
                6,
                4
            ],
            delimiter: " "
        }
    }));
};

// EXTERNAL MODULE: ./src/utils/validation.ts
var validation = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(8597);
// EXTERNAL MODULE: ./src/components/form/Input.tsx
var Input = __webpack_require__(92469);
;// CONCATENATED MODULE: ./src/components/pageForms/employment/EmploymentFormFields.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  label {\n    margin-right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var employmentTypes = [
    "Skrifstofa",
    "Lager",
    "Sala",
    "Verslun"
];
var RadioGroup = styled_components_browser_esm["default"].div(_templateObject());
function validateEmploymentFormFields(param) {
    var name = param.name, ssn = param.ssn, address = param.address, postalCode = param.postalCode, city = param.city, phone = param.phone, family = param.family, email = param.email, type = param.type, job = param.job, hobbies = param.hobbies, education = param.education, references = param.references, hours = param.hours, start = param.start, smoker = param.smoker, file = param.file;
    var errors = {};
    if (!name) {
        errors.name = "H\xe9r vantar nafn";
    }
    if (!ssn) {
        errors.ssn = "H\xe9r vantar kennit\xf6lu";
    } else if (!(0,strings/* isValidSsn */.aR)(ssn)) {
        errors.ssn = "\xd3gild kennitala";
    }
    if (!address) {
        errors.address = "H\xe9r vantar heimilisfang";
    }
    if (!postalCode) {
        errors.postalCode = "H\xe9r vantar p\xf3stn\xfamer";
    }
    if (!city) {
        errors.city = "H\xe9r vantar b\xe6jarf\xe9lag";
    }
    if (!phone) {
        errors.phone = "H\xe9r vantar s\xedman\xfamer";
    } else if (!(0,isValidPhoneNumber/* isValidPhoneNumber */.y)(phone, "IS")) {
        errors.phone = "Ekki leyfilegt s\xedman\xfamer";
    }
    if (!email) {
        errors.email = "H\xe9r vantar netfang";
    } else if (!(0,validation/* validateEmail */.o)(email)) {
        errors.email = "Netfang ekki \xe1 r\xe9ttu formi";
    }
    if (!type) {
        errors.type = "H\xe9r vantar tegund starfs";
    }
    if (!job) {
        errors.job = "H\xe9r vantar n\xfaverandi starf";
    }
    if (!hobbies) {
        errors.hobbies = "H\xe9r vantar \xe1hugam\xe1l";
    }
    if (!education) {
        errors.education = "H\xe9r vantar menntun";
    }
    if (!references) {
        errors.references = "H\xe9r vantar me\xf0m\xe6li";
    }
    if (!hours) {
        errors.hours = "H\xe9r vantar vinnut\xedma";
    }
    if (!start) {
        errors.start = "H\xe9r vantar dagsetningu";
    }
    if (!family) {
        errors.family = "H\xe9r vantar uppl\xfdsingar um fj\xf6lskylduhagi";
    }
    if (!smoker) {
        errors.smoker = "H\xe9r vantar uppl\xfdsingar um reykingar";
    }
    if (!file) {
        errors.file = "H\xe9r vantar ferilskr\xe1";
    }
    return errors;
}
function EmploymentFormFields() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Nafn*",
                    name: "name"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SsnInput, {
                    label: "Kennitala*",
                    name: "ssn"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Heimilisfang*",
                    name: "address"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "P\xf3stn\xfamer*",
                    name: "postalCode",
                    characterLimit: 3
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "B\xe6jarf\xe9lag*",
                    name: "city"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* FormikCleaveInput */.mR, {
                    label: "S\xedmi*",
                    name: "phone",
                    options: {
                        phone: true,
                        phoneRegionCode: "IS"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Netfang*",
                    name: "email",
                    type: "email"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* FormikSelect */.hF, {
                    name: "type",
                    label: "S\xf3tt um*",
                    placeholder: "Veldu",
                    items: employmentTypes,
                    itemToString: function(e) {
                        return e !== null && e !== void 0 ? e : "";
                    },
                    withGutter: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "N\xfaverandi starf*",
                    name: "job"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Fj\xf6lskylduhagir*",
                    name: "family"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Menntun*",
                    name: "education",
                    type: "textarea"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Me\xf0m\xe6li*",
                    name: "references",
                    type: "textarea"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "\xc1hugam\xe1l*",
                    name: "hobbies"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Vinnut\xedmi fr\xe1/til*",
                    name: "hours"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Hven\xe6r getur \xfe\xfa byrja\xf0?*",
                    name: "start"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                    label: "Reykir \xfe\xfa?*",
                    name: "smoker"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                sm: 6,
                lg: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* FormikRadioButton */.u, {
                            name: "time",
                            label: "Framt\xed\xf0arstarf",
                            value: "Framt\xed\xf0arstarf",
                            withGutter: true,
                            defaultChecked: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* FormikRadioButton */.u, {
                            name: "time",
                            label: "T\xedmabundi\xf0 starf",
                            value: "T\xedmabundi\xf0 starf",
                            withGutter: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                col: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* default */.Z, {
                    label: "Ferilskr\xe1 me\xf0 mynd*",
                    name: "file",
                    type: "file",
                    withGutter: true
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pageForms/employment/EmploymentForm.tsx
function EmploymentForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EmploymentForm_templateObject() {
    var data = EmploymentForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    EmploymentForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = EmploymentForm_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = EmploymentForm_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var ButtonWrapper = styled_components_browser_esm["default"].div(EmploymentForm_templateObject());
var Status = styled_components_browser_esm["default"].div(_templateObject1());
var Error = styled_components_browser_esm["default"].div(_templateObject2(), (0,es/* palette */.DG)("red"));
var Form = function(param) {
    var handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting, status = param.status;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmploymentFormFields, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                        type: "submit",
                        disabled: isSubmitting,
                        children: "Senda ums\xf3kn"
                    }),
                    !!(status === null || status === void 0 ? void 0 : status.success) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                        children: status.success
                    }),
                    !!(status === null || status === void 0 ? void 0 : status.error) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        children: status.error
                    })
                ]
            })
        ]
    });
};
var EmploymentFormik = (0,formik_esm/* withFormik */.j0)({
    mapPropsToValues: function() {
        return {
            name: "",
            ssn: "",
            address: "",
            postalCode: undefined,
            city: "",
            phone: "",
            email: "",
            type: "",
            job: "",
            family: "",
            hobbies: "",
            education: "",
            references: "",
            hours: "",
            start: "",
            smoker: "",
            time: "",
            file: undefined
        };
    },
    validate: function(values) {
        return validateEmploymentFormFields(values);
    },
    handleSubmit: function(values, param) {
        var setSubmitting = param.setSubmitting, setStatus = param.setStatus;
        var message = (0,email/* makeEmploymentMessage */.xb)(values);
        (0,sendgrid/* sendEmail */.C)(values.name, "Ums\xf3kn um starf", message, values.file).then(function(res) {
            if (res.status !== 200) {
                setSubmitting(false);
                setStatus({
                    error: "Eitthva\xf0 f\xf3r \xfarskei\xf0is. Vinsamlegast reyndu aftur."
                });
            } else {
                setStatus({
                    success: "Ums\xf3kn m\xf3ttekin"
                });
            }
        });
    },
    displayName: "EmploymentForm"
})(Form);
function EmploymentForm() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmploymentFormik, {});
};

;// CONCATENATED MODULE: ./src/components/pageForms/employment/index.tsx


;// CONCATENATED MODULE: ./src/pages/umsoknir/starf.tsx
function starf_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function starf_templateObject() {
    var data = starf_taggedTemplateLiteral([
        "\n  max-width: 800px;\n  margin-bottom: 24px;\n"
    ]);
    starf_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Wrapper = styled_components_browser_esm["default"].div(starf_templateObject());
var __N_SSG = true;
function Reikningsvidskipti() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* PageContainer */._z, {
        title: "Starfsums\xf3kn | Rekstrarv\xf6rur",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H1, {
                                withGutter: true,
                                children: "S\xe6kja um starf"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmploymentForm, {})
            ]
        })
    });
};


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xb": function() { return /* binding */ makeEmploymentMessage; },
/* harmony export */   "_s": function() { return /* binding */ makeContactFormMessage; }
/* harmony export */ });
/* unused harmony export makeTransactionMessage */
function makeTransactionMessage(param) {
    var name = param.name, ssn = param.ssn, phone = param.phone, email = param.email, address = param.address, city = param.city, postalCode = param.postalCode, poBox = param.poBox, website = param.website, cashierEmail = param.cashierEmail, cashierName = param.cashierName, cashierPhone = param.cashierPhone, employees = param.employees, adminEmail = param.adminEmail, amount = param.amount, paymentMethod = param.paymentMethod, contacts = param.contacts, auditors = param.auditors, owners = param.owners;
    return '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n  <html lang="is">\n  <head>\n    <meta charset="utf-8">\n    <title>Ums\xf3kn um reikningsvi\xf0skipti</title>\n    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />\n  </head>\n\n  <body>\n    <div>\n      <h3>N\xfd ums\xf3kn um reikningsvi\xf0skipti fr\xe1 '.concat(name, "</h3>\n      <p>Kennitala: ").concat(ssn, "</p>\n      <p>S\xedmi: ").concat(phone, "</p>\n      <p>Netfang: ").concat(email, "</p>\n      <p>Heimilisfang: ").concat(address, ", ").concat(postalCode, " ").concat(city, "</p>\n      ").concat(poBox ? "<p>P\xf3stbox: ".concat(poBox, "</p>") : "", "\n      ").concat(website ? "<p>Vefs\xed\xf0a: ".concat(website, "</p>") : "", "\n      <p>Fj\xf6ldi starfsmanna: ").concat(employees, "</p>\n      <p>Nafn gjaldkera: ").concat(cashierName, "</p>\n      <p>Netfang gjaldkera: ").concat(cashierEmail, "</p>\n      <p>S\xedmi gjaldkera: ").concat(cashierPhone, "</p>\n      <h4>Tengili\xf0ir</h4>\n      ").concat(contacts.map(function(contact) {
        return "<div>\n              <p>Nafn tengili\xf0s: ".concat(contact.name, "</p>\n              ").concat(contact.title ? "<p>Starfstitill: ".concat(contact.title, "</p>") : "", "\n              ").concat(contact.phone ? "<p>S\xedmi: ".concat(contact.phone, "</p>") : "", "\n              <p>Netfang tengili\xf0s: ").concat(contact.email, "</p>\n              ").concat(contact.job ? "<p>Starfsheiti: ".concat(contact.job, "</p>") : "", "\n          </div>");
    }), "\n      <h4>\xdattektara\xf0ilar</h4>\n      ").concat(auditors.map(function(auditor) {
        return "<div>\n            <p>Nafn \xfattektara\xf0ila: ".concat(auditor.name, "</p>\n            <p>Kennitala \xfattektara\xf0ila: ").concat(auditor.ssn, "</p>\n          </div>");
    }), "\n      <h4>Eigendur</h4>\n      ").concat(owners.map(function(owner) {
        return "<div>\n            <p>Nafn eiganda: ".concat(owner.name, "</p>\n            <p>Kennitala eiganda: ").concat(owner.ssn, "</p>\n          </div>");
    }), "\n      <p>A\xf0gangur a\xf0 vefverslun RV sendist \xe1 netfangi\xf0: ").concat(adminEmail, "</p>\n      <p>\xc1\xe6tlu\xf0 vi\xf0skipti \xe1 m\xe1nu\xf0i kr: ").concat(amount, "</p>\n      <p>Grei\xf0sluh\xe1ttur: ").concat(paymentMethod, "</p>\n    </div>\n  </body>\n  </html>");
}
function makeEmploymentMessage(param) {
    var name = param.name, email = param.email, ssn = param.ssn, address = param.address, postalCode = param.postalCode, city = param.city, phone = param.phone, education = param.education, family = param.family, hobbies = param.hobbies, hours = param.hours, job = param.job, references = param.references, smoker = param.smoker, start = param.start, time = param.time, type = param.type;
    return '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n  <html lang="is">\n  <head>\n    <meta charset="utf-8">\n    <title>Ums\xf3kn um starf</title>\n    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />\n  </head>\n\n  <body>\n    <div>\n      <h3>N\xfd ums\xf3kn um starf fr\xe1 '.concat(name, "</h3>\n      <p>Kennitala: ").concat(ssn, "</p>\n      <p>S\xedmi: ").concat(phone, "</p>\n      <p>Netfang: ").concat(email, "</p>\n      <p>Heimilisfang: ").concat(address, ", ").concat(postalCode, " ").concat(city, "</p>\n      <p>S\xf3tt um: ").concat(type, "</p>\n      <p>N\xfaverandi starf: ").concat(job, "</p>\n      <p>Fj\xf6lskylduhagir: ").concat(family, "</p>\n      <p>\xc1hugam\xe1l: ").concat(hobbies, '</p>\n      <p>Menntun:</p>\n      <p style="white-space: pre-wrap;">').concat(education, '</p>\n      <p>Me\xf0m\xe6li:</p>\n      <p style="white-space: pre-wrap;">').concat(references, "</p>\n      <p>Vinnut\xedmi fr\xe1/til: ").concat(hours, "</p>\n      <p>Reykir: ").concat(smoker, "</p>\n      <p>Getur byrja\xf0: ").concat(start, "</p>\n      <p>").concat(time, "</p>\n    </div>\n  </body>\n  </html>");
}
function makeContactFormMessage(param) {
    var name = param.name, email = param.email, message = param.message;
    return '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n  <html lang="is">\n  <head>\n    <meta charset="utf-8">\n    <title>N\xfd skilabo\xf0 fr\xe1 rv.is</title>\n    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />\n  </head>\n\n  <body>\n    <div>\n      <h3>N\xfd skilabo\xf0 fr\xe1 '.concat(name, "</h3>\n      <p>Netfang: ").concat(email, '</p>\n      <p>Skilabo\xf0:</p>\n      <p style="white-space: pre-wrap;">').concat(message, "</p>\n    </div>\n  </body>\n  </html>");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [370,60,12,774,888,179], function() { return __webpack_exec__(71162); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);